module.exports = __webpack_public_path__ + "static/media/jira.52896dd5.svg";